import { createContext, useCallback, useState } from "react";

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);
  const [size, setSize] = useState("sm");
  const [title, setTitle] = useState();
  const [type, setType] = useState();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDisableBackdropClick, setIsDisableBackdropClick] = useState(false);

  const handleOpenDialog = ({ title, content, size, type, disableBackdropClick }) => {
    setIsOpen(true);
    setDialogContent(content);
    setSize(size);
    setTitle(title);
    setType(!!type ? type : "form");
    setIsDisableBackdropClick(disableBackdropClick);
  };

  const setDialogSize = useCallback((nextSize) => {
    if (nextSize) setSize(nextSize);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    setDialogContent(null);
    setIsDisableBackdropClick(false);
  }, []);

  const handleToggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <AppContext.Provider
      value={{
        isOpen,
        dialogContent,
        handleOpenDialog,
        closeDialog,
        setDialogSize,
        title,
        size,
        type,
        sidebarOpen,
        handleToggleSidebar,
        handleCloseSidebar,
        isDisableBackdropClick,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
